// @flow

import * as React from "react";

import Image from "../atoms/Image";
import Icon from "../atoms/Icon";
import Modal from "../organisms/Modal";
import MediaCarousel from "../molecules/MediaCarousel";

type PropsType = {
    images: Array,
    variation: any,
};

const ProductGallery = (props: PropsType): React.Node => {
    const classList = ["product-gallery"];
    const [activeImage, setActiveImage] = React.useState(props.images[0] || {});
    const [activeVariationId, setActiveVariationId] = React.useState(
        props.variation.id
    );
    const [showModal, setShowModal] = React.useState(false);
    const [activeImageIndex, setActiveImageIndex] = React.useState(0);

    React.useEffect(() => {
        if (props.variation && props.variation.image) {
            const newVariationImage = props.images.find(image => {
                return props.variation.image.id === image.id;
            });

            if (newVariationImage) {
                // set new variation specific image as active
                setActiveImage(newVariationImage);
            }
        } else {
            // set default first non variation image as active
            setActiveImage(props.images[0]);
        }

        if (props.variation.image) {
            setActiveVariationId(props.variation.image.id);
        }
    }, [props.variation, props.images]);

    React.useEffect(() => {
        const activeImageIndex = props.images.findIndex(image => {
            return image.id
                ? image.id === activeVariationId
                    ? true
                    : false
                : image.src === activeImage.src;
        });
        setActiveImageIndex(activeImageIndex >= 0 ? activeImageIndex : 0);
    }, [activeImage, activeVariationId, props.images]);

    const handleImageThumbClick = image => {
        setActiveImage(image);
        if (image.id) {
            setActiveVariationId(image.id);
        }
    };

    if (!props.images) {
        return null;
    }

    return (
        <>
            <div className={classList.join(" ")}>
                <div
                    className="product-gallery__active-image last-sm"
                    onClick={() => setShowModal(true)}
                >
                    <Image
                        key={activeImage.src}
                        src={activeImage.src}
                        alt={
                            activeImage.alt ||
                            activeImage.caption ||
                            activeImage.name
                        }
                        aspectRatio="1:1"
                    />

                    <div className="product-gallery__expand">
                        <Icon name="expand" width="32px" />
                    </div>
                </div>

                <div className="product-gallery__images first-sm">
                    {props.images.map((image, index) => {
                        const isActive = image.id
                            ? image.id === activeVariationId
                                ? true
                                : false
                            : image.src === activeImage.src;
                        return (
                            <div
                                key={index}
                                className={`product-gallery__images__item ${
                                    isActive ? "is-active" : ""
                                }`}
                                onClick={() => handleImageThumbClick(image)}
                            >
                                <Image
                                    key={image.src}
                                    src={image.src}
                                    alt={
                                        image.alt || image.caption || image.name
                                    }
                                    aspectRatio="1:1"
                                />
                            </div>
                        );
                    })}
                </div>
            </div>

            <Modal
                className="media-carousel-modal"
                active={showModal}
                onClose={() => setShowModal(false)}
                onOverlayClick={() => setShowModal(false)}
            >
                <div className="media-carousel-modal__inner container">
                    <div className="row center-xs">
                        <div className="col-xs-12 col-md-9">
                            <MediaCarousel
                                media={props.images}
                                initialSlide={activeImageIndex}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ProductGallery;
